import {useEffect} from "react";
import PropTypes from "prop-types";
import {sendSlackMessage} from "../models/notifications";


export default function VerticalCard(props) {


    useEffect(() => {


    }, [])


    return (
        <li>
            <figure className="bg-red-400">
                <a href={props.ctaSource} target={props.target} className="bg-green-400">
                    <img
                        decoding="async" alt={props.title} src={props.imageURL} style={{
                        objectFit: "fill"
                    }}
                    />
                </a>
            </figure>
            <h3 className="title">
                <a
                    href={props.ctaSource}
                    target={props.target}>
                    {props.title}
                </a>
            </h3>
            <p>{props.subtitle}</p>
            <p>
                <a className="btn-small"
                   href={props.ctaSource}
                   target={props.target}>
                    {props.ctaString || "Learn more"}
                </a>
            </p>
        </li>
    )
}


VerticalCard.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    imageURL: PropTypes.string,
    ctaSource: PropTypes.string,
    ctaString: PropTypes.string,
    target: PropTypes.string,
}

VerticalCard.defaultProps = {
    target: "_self",
}